// @flow

import React from 'react';

import {
  buildMultipleDataFetcher,
  buildSingleDataFetcher,
} from 'app/general/datafetchers/builders';
import {
  InfiniteListFetcher,
  type InfiniteListFetcherProps,
} from 'app/general/datafetchers/InfiniteListFetcher';
import {getDenormalizedListFactory} from 'app/utils/redux_v2';

import {
  fetchProcedures,
  convertLocationParamsToFetchParams,
} from 'app/procedures/actions';
import type {ProcedureType} from 'app/procedures/types';
import {createImmutableSelector} from 'app/utils/react-utils';
import type {StoreShapeType} from 'app/reducers/types';
import type {StoredResponseType} from 'app/utils/redux_v2';
import {denormalizeDocument} from 'app/procedures/selectors';

export const denormalizeProceduresList =
  getDenormalizedListFactory<ProcedureType>(
    (state) => state.proceduresPage,
    createImmutableSelector<
      StoreShapeType,
      StoredResponseType<ProcedureType>,
      any,
      any,
      any
    >(
      (state) => state.teamsArea.get('basicTeams'),
      (state, procedures) => procedures,
      (basicTeams, response) => {
        return {
          ...response,
          results: response.results.map((p) =>
            denormalizeDocument(basicTeams, p)
          ),
        };
      }
    )
  );

export const MultipleStoredProceduresFetcher =
  buildMultipleDataFetcher<ProcedureType>(
    convertLocationParamsToFetchParams,
    // $FlowFixMe - flow doesn't understand redux-thunk magic
    fetchProcedures,
    denormalizeProceduresList
  );

export const StoredProceduresFetcher = buildSingleDataFetcher<ProcedureType>(
  MultipleStoredProceduresFetcher
);

export const ProceduresInfiniteListFetcher = (
  props: InfiniteListFetcherProps<ProcedureType>
) => (
  <InfiniteListFetcher
    DataFetcher={MultipleStoredProceduresFetcher}
    {...props}
  />
);
